import styled from 'styled-components';

export default styled.div`
	display: grid;
	grid-template-columns: var(--px-200) 1fr var(--px-40);
	gap: var(--spacing-large);
	align-items: center;
`;
